"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_tethering(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#e60000;}.cls-3{opacity:0.06;}")), /*#__PURE__*/React.createElement("title", null, "tethering-hi"), /*#__PURE__*/React.createElement("g", {
    id: "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    className: "cls-1",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.78,164.85A4,4,0,0,1,147,158a72,72,0,1,0-102.06-.15,4,4,0,0,1-5.68,5.63A80,80,0,1,1,176,107.15a79.5,79.5,0,0,1-23.39,56.53A4,4,0,0,1,149.78,164.85Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,108.35c0,.39,0,.77,0,1.15a71.54,71.54,0,0,0,20.89,50.71,4.1,4.1,0,0,1,1,1.65,4,4,0,0,0-1-4A71.53,71.53,0,0,1,24,108.35Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,29.5a80.08,80.08,0,0,1,80,78.85c0-.4,0-.8,0-1.2a80,80,0,0,0-160,0c0,.4,0,.8,0,1.2A80.08,80.08,0,0,1,96,29.5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,109.5c0-.39,0-.77,0-1.15A71.47,71.47,0,0,1,147,158a4,4,0,0,0-1,4,3.88,3.88,0,0,1,1-1.65A71.54,71.54,0,0,0,168,109.5Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.25,147.9a4,4,0,0,1-2.83-1.17,56,56,0,1,1,79.3-.13A4,4,0,0,1,130,141a48,48,0,1,0-68,.12,4,4,0,0,1-2.83,6.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,53.5a56.06,56.06,0,0,1,56,54.85c0-.4,0-.8,0-1.2a56,56,0,0,0-112,0c0,.4,0,.8,0,1.2A56.06,56.06,0,0,1,96,53.5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,109.5c0-.39,0-.77,0-1.15A47.66,47.66,0,0,1,130,141a4,4,0,0,0-1,4,4,4,0,0,1,1-1.64A47.71,47.71,0,0,0,144,109.5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,108.35c0,.38,0,.76,0,1.15a47.64,47.64,0,0,0,14.08,33.92,4,4,0,0,1,1,1.66,4,4,0,0,0-1-4A47.64,47.64,0,0,1,48,108.35Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.21,130.94a4,4,0,0,1-2.83-1.17,32,32,0,1,1,45.67-.44,4,4,0,0,1-5.77-5.54,24,24,0,1,0-34.24.32,4,4,0,0,1-2.83,6.83Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,108.35c0,.38,0,.76,0,1.15a23.83,23.83,0,0,0,7,17,4,4,0,0,1,1,1.66,4,4,0,0,0-1-4A23.78,23.78,0,0,1,72,108.35Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,77.5a32,32,0,0,1,32,30.86c0-.4,0-.8,0-1.21a32,32,0,0,0-64,0q0,.6,0,1.2A32,32,0,0,1,96,77.5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,109.5c0-.47,0-.94,0-1.41a23.86,23.86,0,0,1-6.68,15.7,4,4,0,0,0-.92,3.94,4,4,0,0,1,.92-1.6A23.86,23.86,0,0,0,120,109.5Z",
    transform: "translate(0 0)"
  }))));
}

var _default = ic_tethering;
exports.default = _default;